export const initialState = {
  tasksList: [
    {
      id: 't1',
      status: true,
      category: 'Спорядження',
      text: 'Палатка х1',
    },
    {
      id: 't2',
      status: true,
      category: 'Спорядження',
      text: 'Каремат х1',
    },
    {
      id: 't3',
      status: true,
      category: 'Спорядження',
      text: 'Спальник х1',
    },
    {
      id: 't4',
      status: false,
      category: 'Документи',
      text: 'Паспорт х1',
    },
    {
      id: 't5',
      status: false,
      category: 'Одяг',
      text: 'Штормовка х1',
    },
    {
      id: 't6',
      status: false,
      category: 'Аптечка',
      text: 'Бинт х1',
    },
    {
      id: 't7',
      status: true,
      category: 'Аптечка',
      text: 'Джгут х1',
    },
    {
      id: 't8',
      status: false,
      category: 'Аптечка',
      text: 'Хлоргексидин х1',
    },
    {
      id: 't9',
      status: true,
      category: 'Одяг',
      text: 'Бахіли',
    },
    {
      id: 't10',
      status: true,
      category: 'Одяг',
      text: 'Пончо від дощу',
    },
    {
      id: 't11',
      status: true,
      category: 'Одяг',
      text: 'Трекінгові кросівки',
    },
    {
      id: 't12',
      status: true,
      category: 'Одяг',
      text: 'Вітрівка х1',
    },
    {
      id: 't13',
      status: true,
      category: 'Одяг',
      text: 'Шорти',
    },
    {
      id: 't14',
      status: true,
      category: 'Харчування',
      text: 'Пляшка води',
    },
    {
      id: 't15',
      status: false,
      category: 'Харчування',
      text: 'Снеки',
    },
    {
      id: 't16',
      status: false,
      category: 'Харчування',
      text: 'Сублімати',
    },
    {
      id: 't17',
      status: true,
      category: 'Інше',
      text: 'Сірники',
    },
    {
      id: 't18',
      status: false,
      category: 'Інше',
      text: 'Запальничка',
    },
  ],
  categoryList: [
    {
      id: 'c1',
      name: 'Одяг',
      isDropdown: false,
    },
    {
      id: 'с2',
      name: 'Спорядження',
      isDropdown: false,
    },
    {
      id: 'с3',
      name: 'Документи',
      isDropdown: false,
    },
    {
      id: 'с4',
      name: 'Аптечка',
      isDropdown: false,
    },
    {
      id: 'с5',
      name: 'Харчування',
      isDropdown: false,
    },
    {
      id: 'с6',
      name: 'Інше',
      isDropdown: true,
    },
  ],
};
